import { QButton, QIconButton, QStack, QTooltip } from '@captivateiq/quotient';

import type { MessageButtonSpec } from '@captivateiq/assistant/types';

type MessageButtonBarProps = {
  buttons: MessageButtonSpec[];
  align?: 'left' | 'right';
};

export const MessageButtonBar = ({ buttons, align = 'left' }: MessageButtonBarProps) => {
  if (buttons.length === 0) {
    return null;
  }

  return (
    <QStack
      direction="row"
      spacing="8px"
      sx={{ flexWrap: 'wrap', justifyContent: align === 'right' ? 'flex-end' : 'flex-start' }}
    >
      {buttons.map((button) =>
        button.label ? (
          <QTooltip key={button.id} placement="top" title={button.tooltip}>
            <QButton
              disabled={button.disabled}
              size="small"
              startIcon={button.icon}
              variant={button.variant ?? 'outlined'}
              onClick={button.onClick}
            >
              {button.label}
            </QButton>
          </QTooltip>
        ) : (
          <QTooltip key={button.id} placement="top" title={button.tooltip}>
            <QIconButton disabled={button.disabled} icon={button.icon} size="small" onClick={button.onClick} />
          </QTooltip>
        ),
      )}
    </QStack>
  );
};
